import Vue from 'vue'
import 'normalize.css'
import ProComponent from '@didi-pebble/pro-components-vue'
import { Fragment } from 'vue-frag'

import App from './App.vue'
import router from './router'
import pinia, { useStore } from './store'
import vueI18n, { updateI18nLocale } from './i18n/locale'
import './plugins/pebble-ui'
import { vuePlugin } from '@/plugins/plugin-init-omega'
import SvgIcon from '@/components/svgIcon'
import { initLogin } from '@/plugins/plugin-sso-login'
import { preTool } from '@/utils/pre-switch'
import { initMicroConfig } from '@/config/apps'
import '@/assets/styles/common.scss'
// 旧加特兰项目的全局css
import '@/assets/styles/gattaran-global-old.scss'
import { initSailingRaven } from '@/utils/raven'
import { initElvish } from '@/plugins/elvish'
import { env } from '@/utils'
import { initErrorFilters } from '@/utils/error-filter'
import { initLowCode } from '@/plugins/fuxi-render'
import {
  initSystemImplant,
  isSystemImplant,
  getSystem,
  compareSystemToken,
  delURLSystemParams,
  COMPARE_STATUS,
} from '@/utils/system-implant'
import { updateUserConfig } from '@/services'

Vue.config.productionTip = false
Vue.component('Fragment', Fragment)
Vue.use(vuePlugin).use(ProComponent)
Vue.component('SvgIcon', SvgIcon)
const cliENV = process.env.NODE_ENV
if (cliENV === 'production' || cliENV === 'pre') {
  preTool()
}

// 更新ticket
const systemRedirectUrl = initSystemImplant()
let redirectUrl = initLogin()
const store = useStore()
store.eventListener()
store.expiration(7) // 设置store缓存时间
Promise.all([
  store.app.initUserInfo(),
  store.app.initUserAuthCountry(),
  initMicroConfig(),
  initLowCode(),
])
  .then(async () => {
    const userInfo = env.get('userInfo')
    const systemInfo = getSystem()
    if (isSystemImplant() && systemInfo.country && systemInfo.lang) {
      const gattaranInfo = userInfo
      const countryList = store.app.userAuthCountry
      const result = compareSystemToken(systemInfo, gattaranInfo, countryList)
      console.info(result?.msg)
      if (result.result === COMPARE_STATUS.disagree) {
        // 更新用户信息
        await updateUserConfig(result.info)
        // 清除store中缓存
        store.loginOut()
        window.location.reload()
      }
      if (redirectUrl) {
        redirectUrl = delURLSystemParams(redirectUrl)
      } else {
        redirectUrl = systemRedirectUrl
      }
    }
    // 根据用户环境更新locale
    updateI18nLocale(userInfo.locale)
    // router注册完成切掉token信息
    if (redirectUrl) {
      const path = redirectUrl.replace(new RegExp(`^${process.env.VUE_APP_ROUTER_BASE}`), '')
      await router.push({
        path,
      })
    }
    // nginx转发到/workshop 或其他非/v2的路由 需重定向到 /v2/home
    if (!new RegExp(`^${process.env.VUE_APP_ROUTER_BASE}`).test(location.pathname)) {
      await router.replace('/home')
    }
    // raven
    initSailingRaven()
    initErrorFilters()
    // 全量菜单获取，异步不阻塞执行
    store.menu.getMenuListAll()
    await Promise.all([
      // 获取权限菜单
      store.menu.initMenuList(),
      // 初始化elvish
      initElvish(),
    ])
      .catch(e => {
        console.warn(e)
      })
      .finally(() => {
        new Vue({
          router,
          pinia,
          render: h => h(App),
          i18n: vueI18n,
        }).$mount('#app')
      })
  })
  .catch(e => {
    console.warn(e)
  })
